import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

export async function shareICS(eventTitle: string, startDate: Date) {
  const icsContent = createICSFile(eventTitle, startDate);

  // Guardar en caché como evento.ics
  const fileName = `evento_${Date.now()}.ics`;
  await Filesystem.writeFile({
    path: fileName,
    data: icsContent,
    directory: Directory.Cache,
    encoding: Encoding.UTF8
  });

  // Obtener la URI nativa del fichero
  const uri = await Filesystem.getUri({
    path: fileName,
    directory: Directory.Cache,
  });

  // Compartir con Share plugin
  await Share.share({
    title: 'Añadir al calendario',
    text: 'Archivo de evento',
    url: uri.uri,   // importante: la URI nativa
    dialogTitle: 'Compartir evento',
  });

}

function createICSFile(eventTitle: string, start: Date, durationMinutes = 60): string {
  const end = new Date(start.getTime() + durationMinutes * 60 * 1000);

  const fmt = (d: Date) =>
    `${d.getFullYear()}${String(d.getMonth()+1).padStart(2,"0")}${String(d.getDate()).padStart(2,"0")}T${String(d.getHours()).padStart(2,"0")}${String(d.getMinutes()).padStart(2,"0")}00`;

  const dtStart = fmt(start);
  const dtEnd   = fmt(end);

  return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//HumanPerformApp//ES
BEGIN:VEVENT
SUMMARY:${eventTitle}
DTSTART:${dtStart}
DTEND:${dtEnd}
END:VEVENT
END:VCALENDAR`;
}
